<template>
  <c-button-menu
    ref="employeesMenu"
    :loading="loading && !hasFetched['teachers']"
    :label="employeeName"
    outline
    :menu-options="{
      listItems: employeeMenuItems,
    }"
    :menu-offset="[0, 10]"
    @before-show="openMenu"
  >
    <div class="tw-sticky tw-top-0 tw-z-20 tw-bg-white tw-p-4">
      <c-input
        v-model="searchVal"
        placeholder="Zoek medewerker"
        debounce="300"
        autofocus
        dense
      />
    </div>
  </c-button-menu>
</template>

<script setup>
import CButtonMenu from "shared/components/wrappers/button/CButtonMenu.vue";
import useHelpers from "composables/useHelpers";
import { storeToRefs } from "pinia";
import { useAuthorizationStore } from "store/modules/authorizationStore";
import { useGlobalSchoolDataStore } from "store/modules/globalSchoolDataStore";
import { computed, onMounted, ref } from "vue";

const { schoolId } = useHelpers();

// Authorization Store
const authorizationStore = useAuthorizationStore();
const { impersonateUser } = authorizationStore;

// Webmaster store
const globalSchoolDataStore = useGlobalSchoolDataStore();
const { fetchTeachers } = globalSchoolDataStore;
const { teachers, hasFetched } = storeToRefs(globalSchoolDataStore);

// Refs
const searchVal = ref("");
const loading = ref(false);
const employeeName = ref("");

const employeeMenuItems = computed(() => {
  return teachers.value
    .filter(({ id, full_name, role, shortage, email }) => {
      const searchString = searchVal.value.toLowerCase();

      return (
        full_name.toLowerCase().includes(searchString) ||
        role.toLowerCase().includes(searchString) ||
        shortage.toLowerCase().includes(searchString) ||
        email.toLowerCase().includes(searchString) ||
        id.toString().includes(searchString)
      );
    })
    .map((teacher) => ({
      label: `${teacher.full_name} (${teacher.shortage})`,
      sublabel: teacher.role,
      onClick: () => {
        loginAsEmployee(teacher);
      },
    }));
});

onMounted(async () => {
  employeeName.value =
    localStorage.getItem("employee_shortage") || "Medewerker";
});

const loginAsEmployee = async (teacher) => {
  await impersonateUser({
    userId: teacher.id,
    impersonatedUserType: "employee",
  });
};

const openMenu = async () => {
  loading.value = true;
  await fetchTeachers({ schoolId });
  loading.value = false;
};
</script>
